import { TimeInvariantBase } from '../TimeInvariantBase';
import {
    NumberAttribute,
    getAttributesToSerialize
} from '../attributes';

/**
 * Contains watermark margins & max size for one aspect ratio
 */
export class WatermarkLayout extends TimeInvariantBase {
    override _classType = 'WatermarkLayout';
    override name = 'WatermarkLayout';

    @NumberAttribute()
    marginLeft = 0;
    @NumberAttribute()
    marginTop = 0;
    @NumberAttribute()
    marginRight = 0;
    @NumberAttribute()
    marginBottom = 0;
    @NumberAttribute()
    maxWidth = 0;
    @NumberAttribute()
    maxHeight = 0;


    override get propertiesToSerialize(): Array<string> {
        return getAttributesToSerialize(this);
    }
}
